import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export const useGetProposalPercent = (isValues: boolean = false): any => {
  let url = ''
  if (isValues) {
    url = `/producer/analytics/getProposalPercent?newAdvance=true`
  } else {
    url = `/producer/analytics/getProposalPercent?newAdvance=false`
  }
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      proposalPercent: nestedData,
      proposalPercentLoading: isLoading,
      proposalPercentError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
